import React, { useEffect } from "react";
import "./BodySite.css"
import LoginSite from "./LoginSite";
import "bootstrap/dist/css/bootstrap.min.css";
import { useNavigate, useNavLink, Navigate, useLocation, useSearchParams } from "react-router-dom";
import { useCookies } from "react-cookie";
import CiudadanosService from "../services/CiudadanosService";




const IndexSite = () => {


    const [cookies, setCookie] = useCookies(['access_token', 'hash_login'])

    let expires = new Date()
    expires.setTime(expires.getTime() + (30 * 10000000))
    
    const navigate = useNavigate();
    const location=useLocation();
    const parameters = useSearchParams();
    const queryParameters = new URLSearchParams(window.location.search)
    var  hashInput = queryParameters.get("hash")
    
    //alert(hashInput);

    var  tokenInput = queryParameters.get("token")
    //alert(tokenInput);
    


   
    //var hashInput = location.search.split("=")[1]
    var command = location.search.split("=")[0];

    const validateCorrectHashLogin = (hashLogin) => {
        CiudadanosService.getDatosCiudadano(hashLogin)
        .then((respo)=>{console.log(respo);})
        .catch((error) => {
            localStorage.removeItem("hashLogin");

            console.log(error);
        })
    }
    
    if (command == "?logout"){
        localStorage.removeItem("hashLogin");
      //  setCookie("hash_login", "",{ path: '/',  expires});
        return <LoginSite/>

    } else
    if (hashInput){
      //  setCookie('hash_login', hashInput, { path: '/',  expires})
        //alert("si");
        sessionStorage.setItem("hashLogin", hashInput);
        localStorage.setItem("hashLogin", hashInput)
    }
    else 
        //alert("no");
        if ((localStorage.getItem("hashLogin") === null || localStorage.getItem("hashLogin") == undefined 
        || localStorage.getItem("hashLogin") == "")
       // && (cookies.hash_login==undefined || cookies.hash_login=="")
    ) {
            return <LoginSite/>
;        } else

            validateCorrectHashLogin(localStorage.getItem("hashLogin"));
    ;
    
        const MenuItemView = ({texto, imagen, link}) => {
            return (<>
            <div><div>
            <img className="imageClipMenu"  src={imagen} onClick={()=>{navigate(link)}}/>

            </div>
            <div  className="textClipMenu">
                    {texto}
                </div>
                </div>
            
            </>)
        }

    return (<>
        <main>
  <section>
        <div className="container text-center indexMainContent" >
            <div className="row">
                <div className="col-6"><MenuItemView texto="Turnos" imagen="./boton_turnos.png" link="/turnos"/></div>
                <div className="col-6"><MenuItemView texto="Credencial" imagen="./boton_credencial.png" link="/credencial"/></div>

                {/*<div className="col-4"><MenuItemView texto="Beneficios" imagen="./boton_beneficios.png" link="/beneficios"/></div>*/}
                <div className="col-6"><MenuItemView texto="Estudios M&eacute;dicos" imagen="./boton_estudiosmedicos.png" link="/estudios"/></div>
                <div className="col-6"
                 onClick={()=>{
                    localStorage.setItem("misTipos","CENTROS DE JUBILADOS,CAPS,COMISARIAS Y DESTACAMENTOS,CORREDORES,ESTACIONES,FISCALIAS,HOSPITALES,JARDINES,MUNICIPALES,PRIMARIAS,OFICINAS PUBLICAS,PLAZAS,Punto WIFI Conectados,SECUNDARIAS,UNIVERSIDADES");
                    navigate("/wifi");}}
                ><MenuItemView texto="Mapa Muni" imagen="./boton_mapamuni.png"/></div>

                {/*<div className="col-4"><MenuItemView texto="Agenda" imagen="./boton_agenda.png" link="/agenda"/></div>*/}
                {/*<div className="col-6"><MenuItemView texto="Telemedicina" imagen="./boton_telemedicina.png" link="/telemedicina"/></div>]*/}
                

                <div className="col-6"><MenuItemView texto="Clubes Municipales" imagen="./boton_actividades.png" link="/actividades"/></div>
                <div className="col-6"><MenuItemView texto="Estacionamiento" imagen="./boton_estacionamiento.png" link="/estacionamientoppal"/></div>
                {/*<div className="col-6"><MenuItemView texto="Emergencias" imagen="./boton_emergencias.png" link="/emergencias"/></div>*/}
                {/*<div className="col-4"><MenuItemView texto="Medicina preventiva" imagen="./boton_medicinapreventiva.png" link="/medicina"/></div>*/}
                {/*<div className="col-4"><MenuItemView texto="Billetera Digital" imagen="./boton_billeteradigital.png" link="/beneficios"/></div>*/}
            </div>
          
        </div>
        </section></main>
        </>

    );
   
   
}

export default IndexSite;